import TextField from "@mui/material/TextField";
import { HTMLInputTypeAttribute, ReactNode } from "react";
import { Controller, useFormContext } from "react-hook-form";

export default function ControlledTextField({
  name,
  label,
  rows = 1,
  required,
  fullWidth,
  lengthLimit,
  type,
  showOptional,
  helpText,
  autoComplete,
  stripEmojis,
}: {
  name: string;
  label: string;
  rows?: number;
  required?: boolean;
  fullWidth?: boolean;
  lengthLimit?: number;
  type?: HTMLInputTypeAttribute;
  showOptional?: boolean;
  helpText?: ReactNode;
  autoComplete?: string;
  stripEmojis?: boolean;
}) {
  const { control } = useFormContext();
  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { ref, ...fieldRest }, fieldState }) => (
        <TextField
          label={label}
          variant="outlined"
          inputRef={ref}
          {...fieldRest}
          error={!!fieldState.error}
          helperText={
            fieldState.error
              ? fieldState.error.message
              : showOptional && !fieldRest.value
                ? "Optional"
                : helpText
          }
          multiline={rows > 1}
          rows={rows}
          required={required}
          type={type}
          fullWidth={fullWidth}
          onChange={(event) => {
            let value = event.target.value;
            if (stripEmojis) {
              try {
                value = value.replace(/\p{Extended_Pictographic}/gu, "");
              } catch (error) {
                console.error(
                  "CLIENT_KNOWN_ERROR: Failed to strip emojis:",
                  error
                );
              }
            }
            fieldRest.onChange(value);
          }}
          slotProps={{
            htmlInput: {
              maxLength: lengthLimit,
              autoComplete: autoComplete ?? "new-password", // disable autocomplete and autofill
            },
          }}
        />
      )}
    />
  );
}
